export const getChartField = (salaryPlanTypeId) => {
    switch (salaryPlanTypeId) {
        case 1:
            return 'income_positive';
        case 2:
            return 'income_negative';
        case 3:
            return 'income_neutral';
        default:
            return '';
    }
};